import getSymbolFromCurrency from 'currency-symbol-map';
import { convertNumberToString } from './count.util';
import { NO_VALUE } from './subscription/consts';

const defaultCurrency = 'USD';
const DEFAULT_FIXED = 2;

const getCurrencyString = (amount, currency, fixed) =>
  getSymbolFromCurrency(currency) + convertNumberToString(amount, fixed);

const convertNumberToCurrencyString = (
  amount?: string | number,
  currency = defaultCurrency,
  fixed = DEFAULT_FIXED
): string => {
  if (amount === undefined || amount === null || isNaN(Number(amount))) {
    return NO_VALUE;
  }

  const isNegative = Number(amount) < 0;
  const absAmount = Math.abs(Number(amount));

  return isNegative
    ? `-${getCurrencyString(absAmount, currency, fixed)}`
    : getCurrencyString(amount, currency, fixed);
};

export { convertNumberToCurrencyString, defaultCurrency };
